export * from './onboarding-beneficiarios.component';
